/* eslint-disable global-require,import/no-unresolved,max-len,class-methods-use-this */
import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'react-native'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import textStyles from '../../styles/text'
import BulletedListView from '../subcomponents/BulletedListView'
import * as ResourceManager from '../methods/ResourceManager'
import Hyperlink from '../subcomponents/Hyperlink'
import * as RegionalLookup from '../methods/RegionalContentLookUp'
import { gotoSubPage } from '../../actions/helpers'
import styles from '../../styles'
import LightStageDetails from './LightStageDetails'

function TwoCollectingWavesPage(props) {
    const { t, regionalContentLookup } = props
  const sitInFrontKey = regionalContentLookup('troubleshootingSitInFrontOfCommunicator')
  const sitInFrontTestID = sitInFrontKey.includes('Metric') ? 'sit-in-front=communicator-two-metric' : 'sit-in-front=communicator-two'
    return (
      <LightStageDetails
        testID="TwoCollectingWaves"
        analyticsEvent="TwoCollectingWaves"
        sourceImage={ResourceManager.loadImage('two_collecting_waves_header')}
        sourceImageStyle={{ width: 272, height: 59 }}
        accessibilityLabel={t('access:twoCollectingWavesPageImage')}
      >
        <Text style={styles.lightStageHeader} testID="light-state-details-header">{t('common:yellowCollectingTwoTitle')}</Text>
        <Text style={styles.lightStageDetailsHeading}>{t('whatItMeans')}</Text>
        <Text style={textStyles.bodyContentText}>{t('twoCollectingWavesParagraph1')}</Text>
        <Text style={styles.lightStageDetailsHeading}>{t('ifYouSeeThis')}</Text>
        <BulletedListView
          testID="bulletList1"
        >
          <Hyperlink
            accessibilityLabel={t('access:hereLink')}
            testID="communicator-link"
            linkText={t('common:troubleshootingHereLinkText')}
            beforeText={t('common:troubleshootingEnsureCommunicatorPlacement')}
            afterText="."
            onPress={() => gotoSubPage('WhereToPlaceMonitorPage', 'wherePlaceMonitor')}
            textStyle={textStyles.detailText}
          />
          <Text testID={sitInFrontTestID} style={textStyles.detailText}>{t(sitInFrontKey)}</Text>
          <Text style={textStyles.detailText}>{t('common:troubleshootingRemainStillUntilComplete')}</Text>
          <Text style={textStyles.detailText}>{t(regionalContentLookup('troubleshootingMoveWirelessElectronics'))}</Text>
        </BulletedListView>
        <BulletedListView
          headingText={t('common:verifyTroubleshootingListTitle')}
        >
          <Text style={textStyles.detailText}>{t('common:verifyTroubleshootingBulletOne')}</Text>
        </BulletedListView>
      </LightStageDetails>
    )
}

TwoCollectingWavesPage.propTypes = {
  t: PropTypes.func.isRequired,
  regionalContentLookup: PropTypes.func.isRequired,
}

const actionCreators = {
  regionalContentLookup: RegionalLookup.regionalContentLookup,
}

export const TwoCollectingWavesPageComponent = TwoCollectingWavesPage

export default withTranslation(['indicatorLights', 'common'])(connect(null, actionCreators)(TwoCollectingWavesPage))
